import { useEffect } from "react";

// Imperative head manager. React 19 dropped compatibility with react-helmet-async@2,
// so we manage SEO tags directly and deterministically. This mirrors the exact
// backend SEO payload a future Next.js `generateMetadata` will consume.
export default function Seo({ seo, title, description }) {
  useEffect(() => {
    const t = seo?.title || title || "LIVYVIO";
    const desc = seo?.meta_description || description || "";
    const og = seo?.open_graph || {};

    document.title = t;
    // Remove previously-managed tags AND any static description/canonical to prevent duplicates.
    document.querySelectorAll('[data-seo], meta[name="description"], link[rel="canonical"]').forEach((el) => el.remove());

    const head = document.head;
    const add = (tag, attrs, text) => {
      const el = document.createElement(tag);
      Object.entries(attrs).forEach(([k, v]) => { if (v != null) el.setAttribute(k, v); });
      el.setAttribute("data-seo", "1");
      if (text != null) el.textContent = text;
      head.appendChild(el);
    };

    if (desc) add("meta", { name: "description", content: desc });
    if (seo?.canonical) add("link", { rel: "canonical", href: seo.canonical });
    (seo?.hreflang || []).forEach((h) => add("link", { rel: "alternate", hreflang: h.locale, href: h.href }));

    add("meta", { property: "og:title", content: og.title || t });
    if (og.description || desc) add("meta", { property: "og:description", content: og.description || desc });
    if (og.image) add("meta", { property: "og:image", content: og.image });
    if (og.url) add("meta", { property: "og:url", content: og.url });
    add("meta", { property: "og:type", content: og.type || "website" });
    add("meta", { property: "og:site_name", content: og.site_name || "LIVYVIO" });
    add("meta", { name: "twitter:card", content: "summary_large_image" });
    add("meta", { name: "twitter:title", content: t });
    if (desc) add("meta", { name: "twitter:description", content: desc });

    (seo?.jsonld || []).forEach((block) => add("script", { type: "application/ld+json" }, JSON.stringify(block)));

    return () => { document.querySelectorAll("[data-seo]").forEach((el) => el.remove()); };
  }, [seo, title, description]);

  return null;
}
